import Cookies from "js-cookie";
import { getMessage, getOptions } from "../utils/languageUtils";

const seenBefore = Cookies.get("guest_name");

const flowConfig = (lang) => {
  const getMessageLang = (key) => getMessage(key, lang);
  const getOptionsLang = (key) => getOptions(key, lang);

  return {
    // ************ messages *******************
    start: {
      chatDisabled: true,
      message: () =>
        seenBefore
          ? `${getMessageLang("welcome_back")} ${seenBefore}`
          : getMessageLang("welcome_new"),
      transition: { duration: 1000 },
      path: () => (seenBefore ? "offering_help" : "ask_name"),
    },
    ask_name: {
      // chatDisabled: true,
      message: getMessageLang("ask_name"),
      function: (params) =>
        Cookies.set("guest_name", params.userInput, { expires: 1 }),
      path: "say_hi",
    },
    say_hi: {
      chatDisabled: true,
      message: (params) => `${getMessageLang("say_hi")} ${params.userInput}`,
      transition: { duration: 1000 },
      path: "offering_help",
    },

    offering_help: {
      message: getMessageLang("help_prompt"),
      transition: { duration: 1000 },
      path: "show_help_options",
    },

    show_help_options: {
      options: getOptionsLang("help"),
      path: "process_help_options",
    },

    services_options: {
      message: getMessageLang("services_prompt"),
      options: getOptionsLang("services").map((service) => service.text), //convert the array of objects to array of object't values
      path: "process_services_options",
    },

    docs_start: {
      message: getMessageLang("required_documents"),
      transition: { duration: 1000 },
      path: "docs_category_options",
    },
    docs_category_options: {
      message: getMessageLang("choose_category"),
      options: getOptionsLang("docs_categories").map(
        (category) => category.text
      ),
      path: "process_docs_category_options",
    },

    common_questions_options: {
      message: getMessageLang("common_questions_prompt"),
      options: getOptionsLang("common_questions").map((q) => q.text), //convert the array of objects to array of object't values
      path: "process_common_questions_options",
    },

    prompt_again: {
      message: getMessageLang("need_more_help"),
      options: getOptionsLang("help"),
      path: "process_help_options",
    },
    call_support: {
      message: getMessageLang("call_support"),
      transition: { duration: 1000 },
      path: "prompt_again",
    },
    unknown_input: {
      message: getMessageLang("unknown_input"),
      options: getOptionsLang("help"),
      path: "process_help_options",
    },

    // ************ processing options *******************

    process_help_options: {
      transition: { duration: 0 },
      path: async (params) => {
        switch (params.userInput) {
          case getOptionsLang("help")[0]: // View Services
            return "services_options";
          case getOptionsLang("help")[1]: // Docs Categories
            return "docs_start";
          case getOptionsLang("help")[2]: // common questions
            return "common_questions_options";
          default:
            return "unknown_input";
        }
      },
    },

    process_services_options: {
      transition: { duration: 0 },
      path: (params) => {
        const service = getOptionsLang("services").find(
          (option) => option.text === params.userInput
        );
        // console.log(" process_services_options : ", service);
        if (!service) return "unknown_input";

        // Redirect logic (as needed)
        const link = `/tracking-services-det`;
        setTimeout(() => window.open(link, "_self"), 1000);
        return "repeat";
      },
    },

    process_docs_category_options: {
      // transition: { duration: 0 },
      message: (params) => {
        // console.log("params : ", params);
        const category = getOptionsLang("docs_categories").find(
          (option) => option.text === params.userInput
        );
        if (!category) return getMessageLang("unknown_input");
        return category.details;
      },
      options: getOptionsLang("go_back")
        .filter((option) => option.key !== "common_q_go_back")
        .map((option) => option.text),
      path: "handle_go_back_options",
    },

    process_common_questions_options: {
      // transition: { duration: 0 },
      message: (params) => {
        const c_question = getOptionsLang("common_questions").find(
          (q) => q.text === params.userInput
        );
        if (!c_question) return getMessageLang("unknown_input");
        return c_question.details;
      },
      options: getOptionsLang("go_back")
        .filter((option) => option.key !== "category_go_back")
        .map((option) => option.text),
      path: "handle_go_back_options",
    },

    handle_go_back_options: {
      transition: { duration: 0 },
      path: async (params) => {
        // console.log("params", params);
        const match = getOptionsLang("go_back").find((item) => {
          // console.log("item.path", item.path);
          return item.text === params.userInput;
        });
        return match ? match.path : "unknown_input";
      },
    },

    repeat: {
      transition: { duration: 3000 },
      path: "prompt_again",
    },
  };
};

export default flowConfig;
